import React, { useMemo } from "react";
import Navbar from "../components/Navbar";
import { Trophy, BarChart3, Flame } from "lucide-react";

const Evaluation = () => {
 
  const historique = [
    { date: "2025-01-15", test: "Quizz : Html/Css", score: 85, temps: 8, niveau: "Débutant" },
    { date: "2025-01-16", test: "Quizz : Html/Css", score: 90, temps: 8, niveau: "Intermédiaire" },
    { date: "2025-01-17", test: "Quizz : Html/Css", score: 60, temps: 10, niveau: "Débutant" },
  ];

 
  const meilleurScore = useMemo(() => {
    return Math.max(...historique.map((item) => item.score));
  }, [historique]);

  const scoreMoyen = useMemo(() => {
    return Math.round(
      historique.reduce((acc, curr) => acc + curr.score, 0) / historique.length
    );
  }, [historique]);

  const serieActuelle = useMemo(() => {
    let count = 0;
    for (let i = historique.length - 1; i >= 0; i--) {
      if (historique[i].score >= 50) count++;
      else break;
    }
    return count;
  }, [historique]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      <div className="w-full max-w-[1000px] mx-auto px-6 py-8">
       
        <h1 className="text-4xl font-bold text-center text-teal-600 mb-2">
          Vos score
        </h1>
        <p className="text-gray-500 font-bold  text-center mb-10">
          Suivez votre progression et vos performances
        </p>

      
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10 text-center">
          <div>
            <Trophy size={40} className="text-yellow-500 mx-auto mb-2" />
            <h3 className="text-lg font-semibold">Meilleur score</h3>
            <p className="text-2xl font-bold text-teal-600">{meilleurScore}</p>
          </div>

          <div>
            <BarChart3 size={40} className="text-orange-400 mx-auto mb-2" />
            <h3 className="text-lg font-semibold">Score moyen</h3>
            <p className="text-2xl font-bold text-orange-500">{scoreMoyen}</p>
          </div>

          <div>
            <Flame size={40} className="text-red-500 mx-auto mb-2" />
            <h3 className="text-lg font-semibold">Série actuelle</h3>
            <p className="text-2xl font-bold text-red-500">{serieActuelle}</p>
          </div>
        </div>

       
        <div className="bg-teal-600 text-white rounded-t-2xl px-6 py-3 font-semibold">
          Historique des tests
        </div>
        <div className="bg-white shadow rounded-b-2xl overflow-x-auto">
          <table className="min-w-full text-left border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 px-4 text-gray-700 font-semibold">Date</th>
                <th className="py-3 px-4 text-gray-700 font-semibold">Test</th>
                <th className="py-3 px-4 text-gray-700 font-semibold">Score</th>
                <th className="py-3 px-4 text-gray-700 font-semibold">Temps</th>
                <th className="py-3 px-4 text-gray-700 font-semibold">Niveau</th>
              </tr>
            </thead>
            <tbody>
              {historique.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4">{item.date}</td>
                  <td className="py-3 px-4">{item.test}</td>
                  <td className="py-3 px-4 font-bold text-green-600">{item.score}%</td>
                  <td className="py-3 px-4">{item.temps} mn</td>
                  <td className="py-3 px-4">
                    <span
                      className={`px-3 py-1 text-xs font-semibold rounded-full 
                        ${item.niveau === "Débutant" ? "bg-red-100 text-red-500" : "bg-yellow-100 text-yellow-600"}
                      `}
                    >
                      {item.niveau}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default Evaluation;
